module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"manager_review_desc":"이 리뷰는 %{brandName} 관리자가 등록한 리뷰입니다."}}')
  delete Component.options._Ctor
}
